type SearchFunction = (search: string) => Promise<{ value: string }[]>

export function withValueMapping(searchFn: SearchFunction) {
  return (search: string) =>
    searchFn(search).then(results =>
      results.map(({ value }) => {
        return {
          id: value,
          value,
        }
      })
    )
}
